import { render, staticRenderFns } from "./TreatmentRequestList.vue?vue&type=template&id=fe719432&scoped=true&"
import script from "./TreatmentRequestList.vue?vue&type=script&lang=ts&"
export * from "./TreatmentRequestList.vue?vue&type=script&lang=ts&"
import style0 from "./TreatmentRequestList.vue?vue&type=style&index=0&id=fe719432&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe719432",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VChip,VDataTable,VSelect,VTextField})
